module.exports = __webpack_public_path__ + "static/media/Open-Sou-Int.2ff2c6a9.png";